export const testimonials = [
  {
    id: 1,
    name: "Marcus T.",
    location: "Dallas, TX",
    rating: 5,
    text: "KISA Cooling came out same-day when my AC failed during a 104° July afternoon. Had the system diagnosed and repaired within two hours. Unbelievably fast, professional, and fair pricing. These guys are the real deal.",
    date: "July 2025",
  },
  {
    id: 2,
    name: "Sandra R.",
    location: "Plano, TX",
    rating: 5,
    text: "We had a full system replacement done by KISA Cooling and the experience was outstanding from start to finish. They explained every step, gave us transparent pricing, and the installation was complete in one day. Our energy bill dropped significantly.",
    date: "August 2025",
  },
  {
    id: 3,
    name: "David K.",
    location: "Richardson, TX",
    rating: 5,
    text: "The technician was incredibly knowledgeable. He didn't just fix the issue — he took time to explain what caused it and how to prevent it in the future. That kind of service is rare. Will absolutely use KISA again.",
    date: "June 2025",
  },
  {
    id: 4,
    name: "Jennifer M.",
    location: "Irving, TX",
    rating: 5,
    text: "Called at 8am, tech was here by 10am. My commercial AC unit was failing and KISA got it back online before my business opened. Saved the day. Highly recommend for commercial clients.",
    date: "September 2025",
  },
  {
    id: 5,
    name: "Carlos E.",
    location: "Garland, TX",
    rating: 5,
    text: "Preventative maintenance service was incredibly thorough. They caught a failing capacitor before it became a major issue. Proactive, professional, and honest. Signed up for their annual plan immediately.",
    date: "May 2025",
  },
  {
    id: 6,
    name: "Amanda W.",
    location: "Mesquite, TX",
    rating: 5,
    text: "I've used three different HVAC companies over the years and KISA is by far the best. Their technicians actually know their craft. No upselling, no runaround — just solid, efficient work at a fair price.",
    date: "October 2025",
  },
];